module.exports = __webpack_public_path__ + "img/T2B_xs_00.283ccf42.png";